/**
 * Category labels/order and display-ordering constants for the Integrations modal.
 */
import type { ProviderCategory } from '@/lib/api/endpoints/integrations';

export const CATEGORY_LABELS: Record<ProviderCategory | 'all', string> = {
  all: 'All',
  health: 'Health',
  productivity: 'Productivity',
  business: 'Business',
  developer: 'Developer',
};

export const CATEGORY_ORDER: (ProviderCategory | 'all')[] = [
  'all',
  'health',
  'productivity',
  'business',
  'developer',
];

// Display order for integrations (OAuth integrations first, then the rest)
export const DISPLAY_ORDER: string[] = [
  'google',      // OAuth
  'microsoft',   // OAuth
  'fitbit',      // OAuth
  'strava',      // OAuth
  'shopify',     // OAuth
  'github',      // OAuth
  // Other integrations
  'notion',
  'apple_health',
  'stripe',
  'google_analytics',
  'toggl',
  'linear',
  'oura',
  'whoop',
  'custom',
];
